import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import TrainingLogbooksTabAddFile from './Elements/TrainingLogbooksTabAddFile';
import TrainingCertificationLogbooksModal from './Elements/TrainingCertificationLogbooksModal';


// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class TrainingCertificationLogbooksIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      training_certification_logbooks: [],
      training_certification_id: null,
      date: null,
      start: null,
      finish: null,
      training_certifications_select: [],
      staff_list: [],
      training_certification_logbook: {},
      modal_props: false,
      modal_duplicate_props: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.editModal = this.editModal.bind(this);
    this.closeModalParent = this.closeModalParent.bind(this);
    this.updateDataModal = this.updateDataModal.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.ArchiveButtons = this.ArchiveButtons.bind(this);
    this.StatusButtons = this.StatusButtons.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData(event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/usuario/logbooks';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({training_certification_logbooks: responseJson.data.main, training_certifications_select: responseJson.data.training_certifications_select, staff_list: responseJson.data.staff_list});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */
    });
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      training_certification_id: this.state.training_certification_id,
      date: this.state.date,
      start: this.state.start,
      finish: this.state.finish,
      examiner_id: this.state.examiner_id,
      instructor_id: this.state.instructor_id,
      pf_id: this.state.pf_id,
      pm_id: this.state.pm_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado/logbook', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.loadData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  delete (id) {
    var training_certification_logbook_id = id;
    var confirm = window.confirm(this.locale.Sessoes.AdicionarSessao.deletar);
    if (confirm) {
      var self = this;
      self.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/logbook/' + training_certification_logbook_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.loadData(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  updateDataModal (responseJson) {
    var header = this.setState({updated: 1});
    var self = this;
    Promise.resolve(header).then(function(value) {
      self.editModal(responseJson);
    });
  }

  editModal (event) {
    if (this.state.updated == 0) {
      var training_certification_logbook_id = event.id;
      this.handleAlert('', '', 'open');
    } else {
      var training_certification_logbook_id = event.data.training_certification_logbook_id;
    }
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/treinamento/certificado/logbook/tripulantes/' + training_certification_logbook_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          if (self.state.updated == 1) {
            self.handleAlert(event.message, event.status, 'open');
          } else {
            self.setState({modal_props: true, training_certification_logbook: event, training_certification_logbook_staffs: responseJson.data, training_certification_logbook_id: training_certification_logbook_id});
            self.handleAlert('', '', 'closed');
          }
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      });
    });
  }

  finalize (id) {
    var training_certification_logbook_id = id;
    var confirm = window.confirm(this.locale.Sessoes.AdicionarSessao.finalizar);
    if (confirm) {
      var datasave = {
      };
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/logbook/finalizar/' + training_certification_logbook_id, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.loadData(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  reopen (id) {
    var training_certification_logbook_id = id;
    var confirm = window.confirm(this.locale.Sessoes.AdicionarSessao.reabrir);
    if (confirm) {
      var datasave = {
      };
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificado/logbook/reabrir/' + training_certification_logbook_id, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.loadData(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  closeModalParent() {
    var responseJson = {
      status: 'success',
      message: this.locale.Sessoes.AdicionarSessao.osDadosForamAtualizadosComSucesso,
    };
    this.handleAlert('', '', 'open');
    this.setState({modal_props: false, modal_duplicate_props: false, updated: 0}, this.loadData(responseJson));
  }

  StatusButtons (cell, row) {
    if (row.status === 0) {
      var botao = (
        <span className="label label-danger">{this.locale.Sessoes.AdicionarSessao.botaoAberto}</span>
      );
    }
    if (row.status === 1) {
      var botao = (
        <span className="label label-primary">{this.locale.Sessoes.AdicionarSessao.botaoFinalizado}</span>
      );
    }
    if (row.status === 2) {
      var botao = (
        <span className="label label-success">{this.locale.Sessoes.AdicionarSessao.botaoConfirmado}</span>
      );
    }
    return botao;
  }

  ActionsButtons (cell, row) {
    if (row.status === 0) {
      var botao = (
        <div className="btn-group">
          <button className="btn btn-primary btn-sm" onClick={() => this.editModal(row)}>
            <i className="fa fa-fw fa-users"></i>
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => this.delete(row.id)}>
            <i className="fa fa-fw fa-trash"></i>
          </button>
          <button className="btn btn-success btn-sm" onClick={() => this.finalize(row.id)}>
            <i className="fa fa-fw fa-check"></i>
          </button>
        </div>
      );
    }
    if (row.status === 1) {
      var botao = (
        <div className="btn-group">
          <button className="btn btn-primary btn-sm" onClick={() => this.editModal(row)}>
            <i className="fa fa-fw fa-users"></i>
          </button>
          <button className="btn btn-danger btn-sm" onClick={() => this.reopen(row.id)}>
            <i className="fa fa-fw fa-close"></i>
          </button>

        </div>
      );
    }

    return botao;
  }

  ArchiveButtons (cell, row) {
    var botao = (
      <TrainingLogbooksTabAddFile handleAlert={this.handleAlert} updateData={this.loadData} id={row.id} file={row.file} file_archived={row.file_archived} />
    );
    return botao;
  }

  render() {
    var self = this;
    return (
<div>
  
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Sessoes.AdicionarSessao.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Sessoes.AdicionarSessao.formulario.Treinamento}:</label>
              <Select
                className="form-field-name"
                name="training_certification_id"
                value={this.state.training_certification_id}
                searchable={true}
                placeholder={this.locale.Sessoes.AdicionarSessao.formulario.placeholder.SelecionarCertificado}
                onChange={this.handleSelectChange.bind(this, 'training_certification_id')}
                options={this.state.training_certifications_select}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Sessoes.AdicionarSessao.formulario.Data}:</label>
              <InputMask value={this.state.date}  maskChar={null} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder={this.locale.Sessoes.AdicionarSessao.formulario.placeholder.Data} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Sessoes.AdicionarSessao.formulario.Inicio}:</label>
              <InputMask value={this.state.start}  maskChar={null} name="start" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'start')} placeholder={this.locale.Sessoes.AdicionarSessao.formulario.placeholder.HorarioDeInicio} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Sessoes.AdicionarSessao.formulario.Fim}:</label>
              <InputMask value={this.state.finish}  maskChar={null} name="finish" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'finish')} placeholder={this.locale.Sessoes.AdicionarSessao.formulario.placeholder.HorarioDeFim} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Sessoes.AdicionarSessao.formulario.Examinador}:</label>
              <Select
                className="form-field-name"
                name="examiner_id"
                value={this.state.examiner_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'examiner_id')}
                options={this.state.staff_list}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Sessoes.AdicionarSessao.formulario.Instrutor}:</label>
              <Select
                className="form-field-name"
                name="instructor_id"
                value={this.state.instructor_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'instructor_id')}
                options={this.state.staff_list}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Sessoes.AdicionarSessao.formulario.PilotFlying}:</label>
              <Select
                className="form-field-name"
                name="pf_id"
                value={this.state.pf_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'pf_id')}
                options={this.state.staff_list}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>{this.locale.Sessoes.AdicionarSessao.formulario.PilotMonitoring}:</label>
              <Select
                className="form-field-name"
                name="pm_id"
                value={this.state.pm_id}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'pm_id')}
                options={this.state.staff_list}
              />
            </div>
          </div>
        </div>
        <hr/>
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-plus"></i> {this.locale.Sessoes.AdicionarSessao.formulario.botaoAdicionarSessao}</button>
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.Sessoes.AdicionarSessao.tituloListaDeSessoes}</h3>
      <hr/>
      <BootstrapTable data={this.state.training_certification_logbooks} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Sessoes.AdicionarSessao.tabela.semTarefas}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 50, placeholder: ' '}} width='60'>{this.locale.Sessoes.AdicionarSessao.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 50, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Sessoes.AdicionarSessao.tabela.Treinamento}</TableHeaderColumn>
        <TableHeaderColumn dataField="certification" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 50, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Sessoes.AdicionarSessao.tabela.Certificado}</TableHeaderColumn>
        <TableHeaderColumn dataField="start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 50, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Sessoes.AdicionarSessao.tabela.Inicio}</TableHeaderColumn>
        <TableHeaderColumn dataField="finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 50, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Sessoes.AdicionarSessao.tabela.Fim}</TableHeaderColumn>
        <TableHeaderColumn dataField="hours_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 50, placeholder: this.locale.general.procurar}} width='120'>{this.locale.Sessoes.AdicionarSessao.tabela.HorasTotais}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ArchiveButtons} width='300'>{this.locale.Sessoes.AdicionarSessao.tabela.Arquivo}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.StatusButtons} width='120'>{this.locale.Sessoes.AdicionarSessao.tabela.Status}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='200'>{this.locale.Sessoes.AdicionarSessao.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
      <TrainingCertificationLogbooksModal handleAlert={this.handleAlert} staff_list={this.state.staff_list} training_certification_logbook={this.state.training_certification_logbook} training_certification_logbook_staffs={this.state.training_certification_logbook_staffs} training_certification_logbook_id={this.state.training_certification_logbook_id} modal_props={this.state.modal_props} updateData={this.loadData} closeModalParent={this.closeModalParent} updateDataModal={this.updateDataModal} updated={this.state.updated} />
    </div>
  </div>
</div>
    );
  }
}

export default TrainingCertificationLogbooksIndex;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationLogbooks/TrainingCertificationLogbooksIndex.js